import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../config";

const EMPTY_FC = { type: "FeatureCollection", features: [] };

const useJunctionGeom = (junctionId) => {
  const [approachGeojson, setApproachGeojson] = useState(EMPTY_FC);
  const [exitLineGeojson, setExitLineGeojson] = useState(EMPTY_FC);
  const [exitArrowGeojson, setExitArrowGeojson] = useState(EMPTY_FC);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (junctionId == null) {
      setApproachGeojson(EMPTY_FC);
      setExitLineGeojson(EMPTY_FC);
      setExitArrowGeojson(EMPTY_FC);
      return;
    }

    let isMounted = true;
    setLoading(true);
    const headers = { "X-API-Key": config.FLYOVER_RCM_API_TOKEN };

    Promise.all([
      axios.get(`${config.FLYOVER_RCM_API_URL}/approach/geom`, { headers, params: { junctionId } }),
      axios.get(`${config.FLYOVER_RCM_API_URL}/exit/geom`, { headers, params: { junctionId } }),
    ])
      .then(([approachRes, exitRes]) => {
        if (!isMounted) return;
        setApproachGeojson(approachRes.data?.data?.[0]?.geojson ?? EMPTY_FC);

        const exitFc = exitRes.data?.data?.[0]?.geojson ?? EMPTY_FC;
        const features = exitFc.features ?? [];
        setExitLineGeojson({
          type: "FeatureCollection",
          features: features.filter((f) => f.geometry?.type === "LineString"),
        });
        setExitArrowGeojson({
          type: "FeatureCollection",
          features: features.filter((f) => f.geometry?.type === "Polygon"),
        });
      })
      .catch((err) => {
        console.error("useJunctionGeom: fetch failed", err);
        if (isMounted) {
          setApproachGeojson(EMPTY_FC);
          setExitLineGeojson(EMPTY_FC);
          setExitArrowGeojson(EMPTY_FC);
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [junctionId]);

  return { approachGeojson, exitLineGeojson, exitArrowGeojson, loading };
};

export default useJunctionGeom;
